import React from "react";
import { Box, Typography } from "@mui/material";
import { typography } from "../../theme/designSystem";

// Card padrão de resumo dos relatórios (padrão global do projeto).
// Modelo: rótulo pequeno cinza + valor em destaque colorido + sublinha e nota opcionais.
export interface ReportSummaryCardProps {
  label: string;
  value: string;
  color?: string;
  sub?: string;
  /** cor da sublinha (ex.: pendência em laranja); default cinza */
  subColor?: string;
  note?: string;
}

export const summaryCardsRowSx = {
  display: "flex",
  gap: 2,
  flexWrap: "wrap" as const,
  mb: 3,
};

const cardSx = {
  flex: "1 1 150px",
  minWidth: 150,
  backgroundColor: "white",
  borderRadius: "8px",
  border: "1px solid #e9ecef",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)",
  padding: "0.75rem 1rem",
};

const ReportSummaryCard: React.FC<ReportSummaryCardProps> = ({ label, value, color, sub, subColor, note }) => (
  <Box sx={cardSx}>
    <Typography sx={{ fontSize: 12, color: "#6c757d" }}>{label}</Typography>
    <Typography
      sx={{
        fontSize: 20,
        fontWeight: typography.fontWeight.semibold,
        color: color || "#2D3748",
        lineHeight: 1.3,
      }}
    >
      {value}
    </Typography>
    {sub && <Typography sx={{ fontSize: 12, color: subColor || "#adb5bd" }}>{sub}</Typography>}
    {note && <Typography sx={{ fontSize: 11, color: "#ced4da" }}>{note}</Typography>}
  </Box>
);

export default ReportSummaryCard;
